import { FormControl, Grid, IconButton, InputLabel, Select, TextField, Typography, Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Add as IconAdd, Delete as IconDelete, Edit as IconEdit } from "@mui/icons-material";
import comprobanteService from "../services/comprobanteService";
import * as servicioService from "../services/servicioService";
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { init, setEntity, setData, setValidationMessage, activeValidations
  , setListConceptoCobro, defaultReceiptDetail as defaultReceiptDetailImport } from "../redux/receiptDetailSlice";
import { FormHelperText as HelperText } from '@mui/material';
import DialogYesNo from './DialogYesNo';

const ReceiptDetail = (props) => {
    const isReadOnly = props.isReadOnly;
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const params = useParams();
    const setDetails = props.setDetails;
    // Solo se pide confirmacion al borrar si el comprobante ya esta registrado.
    const esNuevo = props.esNuevo;

    useEffect(() => {
        dispatch(init({ sliceKey }));
    }, [dispatch, sliceKey]);

    const entity = useSelector((state) => state.receiptDetail[sliceKey]?.entity);
    const listConceptoCobro = useSelector((state) => state.receiptDetail[sliceKey]?.listConceptoCobro);
    const validate = useSelector((state) => state.receiptDetail[sliceKey]?.validationActive);
    const [listDetails, setListDetails] = useState([]);
    const [editingIndex, setEditingIndex] = useState(-1);
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectIndexDelete, setSelectIndexDelete] = useState(-1);

    const fetchListConceptoCobro = async () => {
        const data = await servicioService.getsConceptoCobroView({
                idServicio: 0,
                idFilial: 0,
                idTipo: 0,
                sesionesMes: 0,
                idEstado: 2,
            })
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListConceptoCobro({sliceKey: sliceKey, data: data}));
    }

    const fetchDetails = useCallback(async () => {
        if (params.id > 0) {
            const response = await comprobanteService.getsComprobanteDetalleView(params.id)
                .catch((err) => {
                    console.log("Err: ", err);
                });
            const details = response?.data?.data || [];

            setListDetails(details);
            if (setDetails) setDetails(details);
        }
    }, [params.id]);

    useEffect(() => {
        fetchListConceptoCobro();
        fetchDetails();
    }, [fetchDetails]);

    var validation = {
        cantidad: {
            error: entity?.cantidad == 0 || entity?.cantidad == null,
            message: "Ingrese la cantidad",
        },
        idConceptoCobro: {
            error: entity?.idConceptoCobro == 0 || entity?.idConceptoCobro == null,
            message: "Seleccione el concepto de cobro",
        },
        precioUnitario: {
            error: entity?.precioUnitario == 0 || entity?.precioUnitario == null,
            message: "Ingrese el precio unitario",
        },
    }

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    useEffect(() => {
        dispatch(setValidationMessage({sliceKey: sliceKey, message: messagesValidation()}));
    }, [entity])

    var setDataEntity = e => {
        dispatch(setData({sliceKey: sliceKey, name: e.target.name, value: e.target.value}));
    }

    const handleAddDetail = () => {
        var messages = messagesValidation();
        if (messages.length > 0) {
            dispatch(activeValidations({sliceKey: sliceKey}));
            return;
        }

        var newDetail = {
            id: 0,
            numero: listDetails.length + 1,
            cantidad: entity.cantidad,
            cantidadStock: entity.cantidadStock || 0,
            idConceptoCobro: entity.idConceptoCobro,
            conceptoCobro: entity.conceptoCobro,
            precioUnitario: entity.precioUnitario,
            subTotal: entity.precioUnitario * entity.cantidad,
        };

        var newList = [...listDetails, newDetail];
        setListDetails(newList);
        if (setDetails) setDetails(newList);
        dispatch(setEntity({sliceKey: sliceKey, data: defaultReceiptDetailImport}));
    }

    const handleEditDetail = (index) => {
        setEditingIndex(index);
        dispatch(setEntity({sliceKey: sliceKey, data: listDetails[index]}));
    }

    const handleUpdateDetail = () => {
        var messages = messagesValidation();
        if (messages.length > 0) {
            dispatch(activeValidations({sliceKey: sliceKey}));
            return;
        }

        var updatedDetail = {
            ...listDetails[editingIndex],
            cantidad: entity.cantidad,
            cantidadStock: entity.cantidadStock || 0,
            idConceptoCobro: entity.idConceptoCobro,
            conceptoCobro: entity.conceptoCobro,
            precioUnitario: entity.precioUnitario,
            subTotal: entity.precioUnitario * entity.cantidad,
        };

        var newList = [...listDetails];
        newList[editingIndex] = updatedDetail;
        setListDetails(newList);
        if (setDetails) setDetails(newList);
        setEditingIndex(-1);
        dispatch(setEntity({sliceKey: sliceKey, data: defaultReceiptDetailImport}));
    }

    const eliminarDetail = (index) => {
        var newList = listDetails.filter((_, i) => i !== index);
        setListDetails(newList);
        if (setDetails) setDetails(newList);

        if (editingIndex === index) {
            setEditingIndex(-1);
            dispatch(setEntity({sliceKey: sliceKey, data: defaultReceiptDetailImport}));
        }
    }

    const handleDeleteDetail = (index) => {
        if (esNuevo) {
            eliminarDetail(index);
            return;
        }

        setSelectIndexDelete(index);
        openCloseDialogDelete();
    }

    const handleCancelEdit = () => {
        setEditingIndex(-1);
        dispatch(setEntity({sliceKey: sliceKey, data: defaultReceiptDetailImport}));
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Detalle del Comprobante
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={6} sm={2}>
                    <TextField
                        required
                        name="cantidad"
                        label="Cantidad"
                        fullWidth
                        type="number"
                        value={entity?.cantidad || 0}
                        onChange={setDataEntity}
                        error={validate?.cantidad && validation.cantidad.error}
                        helperText={validate?.cantidad && validation.cantidad.error ? validation.cantidad.message : ""}
                        disabled={isReadOnly}
                        size="small"
                        inputProps={{ min: 1 }}
                    />
                </Grid>
                <Grid item xs={8} sm={4}>
                    <FormControl required fullWidth error={validate?.idConceptoCobro && validation.idConceptoCobro.error}>
                        <InputLabel htmlFor="input-conceptoCobro">Concepto de Cobro</InputLabel>
                        <Select
                            native
                            label="Concepto de Cobro"
                            value={entity?.idConceptoCobro || 0}
                            onChange={(event) => {
                                dispatch(setData({sliceKey: sliceKey, name: "idConceptoCobro", value: event.target.value}))

                                var concepto = listConceptoCobro?.find((row) => row.id == event.target.value);
                                if (concepto) {
                                    dispatch(setData({sliceKey: sliceKey, name: "conceptoCobro", value: concepto.descripcion}))
                                    dispatch(setData({sliceKey: sliceKey, name: "precioUnitario", value: concepto.monto}))
                                }
                            }}
                            inputProps={{
                                name: 'idConceptoCobro',
                                id: 'input-conceptoCobro',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listConceptoCobro?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate?.idConceptoCobro && validation.idConceptoCobro.error ? validation.idConceptoCobro.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={2}>
                    <TextField
                        required
                        name="precioUnitario"
                        label="Precio Unitario"
                        fullWidth
                        type="number"
                        value={entity?.precioUnitario || 0}
                        onChange={setDataEntity}
                        error={validate?.precioUnitario && validation.precioUnitario.error}
                        helperText={validate?.precioUnitario && validation.precioUnitario.error ? validation.precioUnitario.message : ""}
                        disabled={isReadOnly}
                        size="small"
                        inputProps={{ step: 0.01, min: 0 }}
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <TextField
                        disabled
                        name="subTotal"
                        label="Sub Total"
                        fullWidth
                        type="number"
                        value={(entity?.precioUnitario || 0) * (entity?.cantidad || 0)}
                        size="small"
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <Box display="flex" alignItems="center" gap={1}>
                        {editingIndex >= 0 ? (
                            <>
                                <Button variant="contained" size="small" onClick={handleUpdateDetail} disabled={isReadOnly}>
                                    Actualizar
                                </Button>
                                <Button variant="outlined" size="small" onClick={handleCancelEdit}>
                                    Cancelar
                                </Button>
                            </>
                        ) : (
                            <Button variant="contained" size="small" onClick={handleAddDetail} startIcon={<IconAdd />} disabled={isReadOnly}>
                                Agregar
                            </Button>
                        )}
                    </Box>
                </Grid>
            </Grid>
            <Grid item xs={12} sx={{ mt: 2 }}>
                <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={{ fontWeight: 'bold' }}>N°</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold' }}>Cantidad</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Concepto de Cobro</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>Precio Unitario</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>Sub Total</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold' }}>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listDetails.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell align="center">{index + 1}</TableCell>
                                    <TableCell align="center">{row.cantidad}</TableCell>
                                    <TableCell>{row.conceptoCobro}</TableCell>
                                    <TableCell align="right">{row.precioUnitario?.toFixed(2)}</TableCell>
                                    <TableCell align="right">{row.subTotal?.toFixed(2)}</TableCell>
                                    <TableCell align="center">
                                        <IconButton size="small" disabled={isReadOnly} onClick={() => handleEditDetail(index)}>
                                            <IconEdit fontSize="small" />
                                        </IconButton>
                                        <IconButton size="small" disabled={isReadOnly} onClick={() => handleDeleteDetail(index)}>
                                            <IconDelete fontSize="small" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {listDetails.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        <Typography variant="body2" color="textSecondary">
                                            No hay detalles agregados
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <DialogYesNo
                open={openDialogDelete}
                openClose={openCloseDialogDelete}
                setYes={() => eliminarDetail(selectIndexDelete)}
                setNo={() => { return }}
                titulo={"Borrar Detalle"}
                texto={"Esta seguro de borrar el detalle del comprobante?"}
            ></DialogYesNo>
        </Grid>
    );
}
export default ReceiptDetail;
